import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "header-contentys pt-3 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mr-5" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "text-primary" }, " Accueil ")
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = { class: "body-contentys" }
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = { class: "col-4" }
const _hoisted_7 = { class: "col-4" }
const _hoisted_8 = { class: "col-4" }
const _hoisted_9 = { class: "col-4" }
const _hoisted_10 = { class: "col-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rows_counter = _resolveComponent("rows-counter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.getPermission('voir-camions'))
            ? (_openBlock(), _createBlock(_component_rows_counter, {
                key: 0,
                premier_titre: "Parc auto",
                second_titre: "Camions",
                icon: "/json/camion.json",
                description: "Les camions du reseau yamslogistics ",
                linkName: "camions",
                url: "/api/camions?req_count=1"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.getPermission('voir-courses'))
            ? (_openBlock(), _createBlock(_component_rows_counter, {
                key: 0,
                premier_titre: "Operations",
                second_titre: "Courses",
                icon: "/json/camion.json",
                linkName: "courses",
                description: "Toutes les courses transportées ",
                url: "/api/courses?req_count=1"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.getPermission('voir-course_demandes'))
            ? (_openBlock(), _createBlock(_component_rows_counter, {
                key: 0,
                premier_titre: "Operations",
                second_titre: "Réservations",
                icon: "/json/camion.json",
                linkName: "courses.demandes",
                description: "Toutes les demandes de course en attente ",
                url: "/api/course_demandes?statut=En attente&req_count=1"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.getPermission('voir-clients'))
            ? (_openBlock(), _createBlock(_component_rows_counter, {
                key: 0,
                premier_titre: "Clients",
                second_titre: "Clients",
                icon: "/json/mains.json",
                linkName: "clients",
                description: "Clients repertoriés",
                url: "/api/clients?req_count=1"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.getPermission('voir-proprietaires'))
            ? (_openBlock(), _createBlock(_component_rows_counter, {
                key: 0,
                premier_titre: "Parc-auto",
                second_titre: "Partenaires",
                icon: "/json/mains.json",
                linkName: "proprietaires",
                description: "Propriétaires de camions",
                url: "/api/proprietaires?req_count=1"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.getPermission('voir-employes'))
            ? (_openBlock(), _createBlock(_component_rows_counter, {
                key: 0,
                premier_titre: "Employes",
                second_titre: "Chauffeurs",
                icon: "/json/mains.json",
                linkName: "employes",
                description: "Les employés du type chauffeur",
                url: "/api/employes?poste=Chauffeur&req_count=1"
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}